var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusInCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.3686 16 16 12.3765 16 8C16 3.63137 12.3608 0 7.99216 0C3.61569 0 0 3.63137 0 8C0 12.3765 3.62353 16 8 16ZM8 14.6667C4.29804 14.6667 1.34118 11.702 1.34118 8C1.34118 4.30588 4.2902 1.33333 7.99216 1.33333C11.6863 1.33333 14.6588 4.30588 14.6667 8C14.6745 11.702 11.6941 14.6667 8 14.6667ZM7.97647 11.7255C7.56078 11.7255 7.33333 11.4196 7.33333 10.9804V8.65882H4.88627C4.44706 8.65882 4.13333 8.43137 4.13333 8.01569C4.13333 7.59216 4.42353 7.34902 4.88627 7.34902H7.33333V4.88627C7.33333 4.43922 7.56078 4.14118 7.97647 4.14118C8.4 4.14118 8.65098 4.42353 8.65098 4.88627V7.34902H11.1059C11.5608 7.34902 11.851 7.59216 11.851 8.01569C11.851 8.43137 11.5451 8.65882 11.1059 8.65882H8.65098V10.9804C8.65098 11.4353 8.4 11.7255 7.97647 11.7255Z",
    fill: "#4CAF50"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusInCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PlusInCircle.5f43090020c5a8306dbb58258bded34f.svg";